/* ANNAFOXY Black Friday display. Checkout discounts remain governed by Shopify. */
(function () {
  'use strict';
  var allowed = ['BF10', 'BF20', 'BF30', 'BF40'];
  // Public phase: Shopify applies four automatic collection discounts.
  // Collection membership is already embedded in each product's data-bf-rate.
  var publicSale = window.ANNAFOXY_BF_PUBLIC === true;
  var active = [];
  function normalize(codes) {
    return (Array.isArray(codes) ? codes : []).map(function (c) { return String(c).trim().toUpperCase(); })
      .filter(function (c) { return allowed.indexOf(c) !== -1; });
  }
  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var token = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    if (!token) return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'}).format(cents / 100);
    var precision = /no_decimals/.test(token[1]) ? 0 : 2;
    var decimal = /comma/.test(token[1]) ? ',' : '.';
    var thousands = /apostrophe/.test(token[1]) ? "'" : (/comma/.test(token[1]) ? '.' : ',');
    var number = (cents / 100).toFixed(precision).split('.');
    number[0] = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(token[0], number.join(precision ? decimal : ''));
  }
  function plainMoney(value) {
    // Currency apps may return an HTML span from the money formatter.
    // Our price nodes contain text, so decode that span before assigning textContent.
    var template = document.createElement('template');
    template.innerHTML = String(value);
    return template.content.textContent || '';
  }
  function currentBase(el) {
    var base = Number(el.dataset.bfBase);
    if (!el.dataset.bfVariants) return base;
    try {
      var variants = JSON.parse(el.dataset.bfVariants);
      var container = el.closest('[data-product], [data-product-section], .product, .quick-view-modal') || document;
      var input = container.querySelector('[name="id"]');
      var id = input && Number(input.value);
      if (!id && location.pathname.indexOf('/products/') !== -1) id = Number(new URLSearchParams(location.search).get('variant'));
      var selected = variants.find(function (v) { return v.id === id; });
      return selected ? selected.price : base;
    } catch (e) { return base; }
  }
  function render(el) {
    var rate = Number(el.dataset.bfRate);
    var enabled = rate > 0 && active.indexOf('BF' + rate) !== -1;
    var old = el.querySelector(':scope > .bf-display');
    if (!enabled || !Number.isFinite(currentBase(el))) {
      el.classList.remove('bf-active');
      if (old) old.remove();
      return;
    }
    if (!old) {
      old = document.createElement('span');
      old.className = 'bf-display';
      old.setAttribute('aria-label', 'Black Friday price');
      old.innerHTML = '<s class="bf-original"></s> <span class="bf-sale"></span>';
      el.appendChild(old);
    }
    var base = currentBase(el);
    var sale = Math.round(base * (100 - rate) / 100);
    var formattedBase = plainMoney(money(base));
    var formattedSale = plainMoney(money(sale));
    if (old.querySelector('.bf-original').textContent !== formattedBase) old.querySelector('.bf-original').textContent = formattedBase;
    if (old.querySelector('.bf-sale').textContent !== formattedSale) old.querySelector('.bf-sale').textContent = formattedSale;
    el.classList.add('bf-active');
  }
  function renderAll() { document.querySelectorAll('[data-bf-price]').forEach(render); }
  window.ANNAFOXY_BF = {
    // Call only once Shopify has accepted these discount codes for the visitor's cart.
    setCodes: function (codes) { active = normalize(codes); try { sessionStorage.setItem('annafoxy_bf_expected_codes', JSON.stringify(active)); } catch (error) {} renderAll(); },
    refresh: renderAll,
    getCodes: function () { return active.slice(); }
  };
  var storageKey = 'annafoxy_bf_expected_codes';
  var lastKey = 'annafoxy_bf_previous_cart';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function remember() {
    try { sessionStorage.setItem(storageKey, JSON.stringify(active)); } catch (error) {}
  }
  function loadRemembered() {
    try { return normalize(JSON.parse(sessionStorage.getItem(storageKey) || '[]')); }
    catch (error) { return []; }
  }
  active = publicSale ? allowed.slice() : normalize(loadRemembered().concat(window.ANNAFOXY_BF_INITIAL || []));
  function getCartState() {
    return fetch(root + '?section_id=bf-cart-state', {credentials:'same-origin', cache:'no-store'})
      .then(function (response) { if (!response.ok) throw new Error('Cart state unavailable'); return response.text(); })
      .then(function (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bf-cart-state]');
        if (!node) throw new Error('Cart state section unavailable');
        return JSON.parse(node.textContent);
      });
  }
  function syncCart() {
    if (publicSale) { active = allowed.slice(); renderAll(); return Promise.resolve(); }
    return getCartState().then(function (state) {
      var real = normalize(state.codes);
      var rates = state.items.map(function (item) { return Number(item.rate); });
      var previous = {};
      try { previous = JSON.parse(sessionStorage.getItem(lastKey) || '{}'); } catch (error) {}
      var newlyEligible = active.filter(function (code) {
        return rates.indexOf(Number(code.slice(2))) !== -1 && real.indexOf(code) === -1 && !previous[code];
      });
      // A code for a newly added product may have been pending on an empty cart.
      // Apply it once now, then let Shopify tell us which codes really took effect.
      var apply = newlyEligible.length ? fetch(root + 'cart/update.js', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({discount: normalize(active.concat(real)).join(',')})
      }).then(function (response) { if (!response.ok) throw new Error('Code update failed'); return getCartState(); }) : Promise.resolve(state);
      return apply.then(function (updated) {
        real = normalize(updated.codes);
        rates = updated.items.map(function (item) { return Number(item.rate); });
        active = active.filter(function (code) {
          return rates.indexOf(Number(code.slice(2))) === -1 || real.indexOf(code) !== -1;
        });
        active = normalize(active.concat(real));
        var seen = {};
        active.forEach(function (code) { if (rates.indexOf(Number(code.slice(2))) !== -1 && real.indexOf(code) !== -1) seen[code] = true; });
        try { sessionStorage.setItem(lastKey, JSON.stringify(seen)); } catch (error) {}
        remember(); renderAll();
      });
    });
  }
  function activateLanding() {
    var landing = document.querySelector('[data-bf-landing]');
    if (!landing) return;
    var status = landing.querySelector('[data-bf-status]');
    if (publicSale) {
      if (status) status.textContent = 'Your Black Friday prices are ready.';
      return;
    }
    var codes = allowed.slice();
    fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({discount: codes.join(',')})
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify rejected the discount request');
      return response.json();
    }).then(function () {
      active = codes;
      try { sessionStorage.removeItem(lastKey); } catch (error) {}
      remember(); renderAll();
      status.textContent = 'Your Black Friday prices are ready.';
      return syncCart();
    }).catch(function () {
      status.textContent = 'We could not activate your prices. Please refresh this page.';
      active = []; remember(); renderAll();
    });
  }
  function start() {
    renderAll();
    activateLanding();
    if (!document.querySelector('[data-bf-landing]')) syncCart().catch(function () {
      // Keep the existing state if Shopify's section endpoint is temporarily unavailable.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', function (event) { if (event.persisted) syncCart().catch(function () {}); });
  window.addEventListener('focus', function () { syncCart().catch(function () {}); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncCart().catch(function () {}); });
  setInterval(function () { if (!document.hidden && active.length && !document.querySelector('[data-bf-landing]')) syncCart().catch(function () {}); }, 12000);
  // Handles asynchronously injected collection cards, quick views and Stiletto variant changes.
  var scheduled = false;
  new MutationObserver(function (changes) {
    if (changes.every(function (c) { return c.target.closest && c.target.closest('.bf-display'); })) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; renderAll(); });
  }).observe(document.documentElement, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['value']});
  document.addEventListener('change', function (event) {
    if (event.target.matches('[name="id"]')) requestAnimationFrame(renderAll);
  });
})();
